var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visiable)?_c('el-container',{staticStyle:{"height":"100%"},attrs:{"direction":"vertical"}},[_c('layout-header'),_c('el-container',[_c('layout-sider'),_c('layout-main')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }